import NewDrEventModal from './NewDrEventModal';

export default NewDrEventModal;
